define.alias("checkout/components/seamless-checkout/plan-info-modal", "settings/components/seamless-checkout/plan-info-modal");